import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { IAnimal } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useGetAnimalListByLot(lotId: string, params: any = {}) {
  const { userFarm: farmId } = useAuth()

  return useQuery<IAnimal[], Error>({
    queryKey: ['animalListByLot', lotId, params],
    queryFn: () => animalController.getAnimalListByLoteId(farmId!, lotId, params),
    enabled: !!farmId && !!lotId
  })
}
